import { getItemCookie } from "../utils/cookie";
import { ID_HIDDEN_POPUP_INTRO_GIFT } from "./const";
import moment from "moment";
import { useEffect, useState } from "react";

/**
 * Get current time in Myanmar Time (UTC+6:30)
 * @returns {moment.Moment} Current moment in MMT
 */
export const getMyanmarTime = () => {
  return moment().utcOffset("+06:30");
};

/**
 * Get current hour in Myanmar Time (0-23)
 * @returns {number} Current hour in MMT
 */
export const getMyanmarHour = () => {
  return getMyanmarTime().hour();
};

export const getUrlParamsFromJson = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

export async function checkImage(url) {
  try {
    const res = await fetch(url);
    const buff = await res.blob();
    return buff.type.startsWith("image/");
  } catch (error) {
    // ignore
  }
}

export const handleGetDataTakePrizeMinigame = (dataAwardListMini) => {
  if (!dataAwardListMini) {
    return null;
  }
  const now = moment();
  const cookiePopupIntroGift = getItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT);
  let dataTakePrize = dataAwardListMini.find((item) => {
    if (+item.type_take_prize === 1) {
      if (!cookiePopupIntroGift) {
        return item;
      }
      let isCheckIdShowed = false;

      cookiePopupIntroGift.forEach((gift) => {
        const diffInMinutes = now.diff(gift.timeShowPopup, "minutes");

        if (
          +gift.idTakePrize === +item.id ||
          Math.abs(diffInMinutes) <= 30
        ) {
          isCheckIdShowed = true;
        }
      });
      if (!isCheckIdShowed) {
        return item;
      }
    }
  });

  return dataTakePrize;
};

export const isIntroTourCompleted = (typeIntroTour) => {
  const tourComplete = true;
  return tourComplete === "true" || typeIntroTour?.step === -1;
};

export const useCountDown = () => {
  const [now, setNow] = useState(() => getMyanmarTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(getMyanmarTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const startTime = getMyanmarTime().set({
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const endTime = getMyanmarTime().set({
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const isInPeriod = now.isBetween(startTime, endTime, undefined, "[]");

  let targetTime;

  if (now.isBefore(startTime)) {
    targetTime = startTime;
  } else if (isInPeriod) {
    targetTime = endTime;
  } else {
    targetTime = startTime.clone().add(1, "day");
  }

  const diffSeconds = Math.max(0, targetTime.diff(now, "seconds"));
  const countdown = moment.utc(diffSeconds * 1000).format("HH:mm:ss");

  return {
    countdown,
    isInPeriod,
  };
};

export const handleNumericInput = (data) => {
  return data.replace(/[^0-9]/g, "");
};
